import { useSelector } from 'react-redux';
import { BUYERS_GUIDE } from '~/constants/endpoints';
import { getVehicleDetails } from '~/selectors';

function useBuyersGuideUrl() {
  const {
    make = '',
    model = '',
    remainingWarrantyMiles = 0,
    remainingWarrantyMonths = 0,
    vin = '',
    year
  } = useSelector(getVehicleDetails);

  const url = new URL(BUYERS_GUIDE);
  url.searchParams.set('year', String(year));
  url.searchParams.set('make', make);
  url.searchParams.set('model', model);
  url.searchParams.set('vin', vin);
  url.searchParams.set(
    'hasmanufacturerwarranty',
    remainingWarrantyMiles && remainingWarrantyMonths ? 'true' : 'false'
  );

  return url.toString();
}

export default useBuyersGuideUrl;
